import { Link } from 'react-router-dom';
import { useRegion } from '../contexts/RegionContext';
import LanguageToggle from './LanguageToggle';

const currentYear = new Date().getFullYear();

export const Footer = () => {
  const { t, direction } = useRegion();

  return (
    <footer
      dir={direction}
      className="bg-black/90 backdrop-blur-md border-t border-white/10 mt-auto py-8 px-4 text-center"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Brand */}
        <div className="flex items-center gap-3">
          <img
            src={import.meta.env.BASE_URL + 'AE logo.svg'}
            alt="Active Legend"
            className="w-8 h-8 object-contain"
          />
          <div className={direction === 'rtl' ? 'text-right' : 'text-left'}>
            <span className="text-sm font-black text-white">Active Legend</span>
            <span className="block text-[11px] text-gray-400">{t('footer.brandSubtitle')}</span>
          </div>
        </div>

        {/* Quick Nav Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-300">
          <Link to="/" className="hover:text-primary transition-colors">{t('footer.home')}</Link>
          <span className="text-white/20">•</span>
          <Link to="/games" className="hover:text-primary transition-colors">{t('footer.games')}</Link>
          <span className="text-white/20">•</span>
          <Link to="/blog" className="hover:text-primary transition-colors">{t('footer.blog')}</Link>
          <span className="text-white/20">•</span>
          <Link to="/contact" className="hover:text-primary transition-colors">{t('footer.contact')}</Link>
          <span className="text-white/20">•</span>
          <Link to="/about" className="hover:text-primary transition-colors">{t('footer.about')}</Link>
          <span className="text-white/20">•</span>
          <Link to="/terms" className="hover:text-primary transition-colors">{t('footer.terms')}</Link>
        </div>

        {/* Language & Copyright */}
        <div className="flex items-center gap-4">
          <LanguageToggle showLabel={true} />
          <p className="text-xs text-gray-400 leading-tight m-0">
            &copy; {currentYear} {t('footer.rights')} |{' '}
            <span className="font-bold text-white">Active Legend Studio</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
